import React, { Component } from 'react'
import { withTranslation } from "react-i18next";
import './Header.scss';
import globalConfig from '../../config/global/config.json';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import i18n from '../../i18n';

export class Header extends Component {
    
    gcpLogoPath = () => i18n.exists("configuration:SET_GCP_LOGO_PATH") ? i18n.t("configuration:SET_GCP_LOGO_PATH") : globalConfig.SET_GCP_LOGO_PATH;

    render() {
        const { t } = this.props;
        const langSelector = i18n.exists("configuration:SET_ENABLE_LANG_DROPDOWN") ? this.props.t("configuration:SET_ENABLE_LANG_DROPDOWN") : globalConfig.SET_ENABLE_LANG_DROPDOWN;       
        const displayLang = langSelector === true ? <LanguageSelector/> : null;    
        const locale = sessionStorage.getItem('locale');
        const countryFlag = locale?.slice(-2).toUpperCase();
        const flagTitle = `${countryFlag} ${t("flagAlt")}`
        return (
            <div className="container-fluid head-container px-3">
                <div className="container px-3">
                    <div className="head-container">
                        <div className="left-head-container py-2">
                            <a href={window.location.href} title={t("portalLogoAlt")}>
                                <img className="gcp-logo p-0" src={this.gcpLogoPath()} alt={t("portalLogoAlt")}/>
                            </a>                            
                        </div>
                        <div className="px-0 py-2 right-head-container">
                            {displayLang}      
                            {locale === globalConfig.SET_DEFAULT_MARKET ? null : <div className="text-end flag-container" title={flagTitle}>
                                <img className="flag" src={`/images/flags/${countryFlag}.svg`} alt={flagTitle} />
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withTranslation()(Header)